export default "__VITE_ASSET__49obVCmx__"